import React, { useState } from "react";
import {
  makeStyles,
  Button,
  Box,
  InputAdornment,
  Tabs,
  Tab,
  withStyles,
  FormControlLabel,
  Checkbox,
  Divider,
  Grid,
  MenuItem,
  Radio,
  TextField as TextField2,
} from "@material-ui/core";
import TitleText from "../components/reusableComponents/TitleText";
import { Field, Form, Formik } from "formik";
import DatePicker from "@mui/lab/DatePicker";
import { TextField } from "formik-material-ui";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { setPayment, togglePGModal } from "../reducers/UiReducer";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import seat from "../assets/images/seat.png";
import meal from "../assets/images/meal.png";
import {
  FlightBookEtravDispatch,
  FlightBookDispatch,
  FlightTicketLCCDispatch,
  FlightAddBookingDispatch,
} from "../reducers/HomeReducer";
import paymenthandle from "./HandelPayment";
import { walletBalanceAgentDispatch } from "../reducers/UserReducer";
import ErrorModal from "../components/reusableComponents/ErrorModal";
import etravBooking from "./EtravBookingForm";
import tbobooking from "./TBOBookingLCCForm";
import tbobookingnonlcc from "./TBOBookingNonLCC";
import addBooking from "./FormAddBooking";
import BookingAlreadyPNRModal from "../components/reusableComponents/BookingAlreadyPNRModal";
import Seat from "../components/reusableComponents/Seat";
import WorldlinePG from "../components/reusableComponents/WorldlinePG";
const title = ["Mr", "Mrs"];
const useStyles = makeStyles((theme) => ({
  selectField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #959595",
      },
    },
    backgroundColor: "white",
    marginBottom: 30,
    width: "100%",
    marginTop: 10,
    borderRadius: 5,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 15,
      marginTop: 8,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 5,
    },
    "& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: 5,
    },
  },
  InputPropsStyle: {
    backgroundColor: "white",
    borderRadius: 5,
  },
  inputPropsStyle: {
    padding: 14,
  },
  createButton: {
    backgroundColor: "rgb(239, 51, 57)",
    color: "white",
    borderRadius: 5,
    width: "100%",
    padding: "11px 8px",
    "&:hover": {
      backgroundColor: "rgb(239, 51, 57)",
    },
  },
  tabBorder: {
    borderBottom: "2px solid transparent",
    color: "#7B95AB",
    fontWeight: 400,
  },
  tabBorderColor: {
    borderBottom: "2px solid #313131",
    color: "#00325B",
    fontWeight: 700,
  },
  tab: {
    [theme.breakpoints.up("sm")]: {
      "& .MuiTab-root": {
        minWidth: 241,
        fontSize: 22,
      },
    },
  },
  date: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 5,
      width: "100%",
    },
  },
  dob: {
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  passport: {
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  root: {
    "& .MuiFormHelperText-root": {
      fontSize: 12,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "13px 14px",
    },
    "& MuiInputLabel-root": {
      fontSize: 16,
    },
    "& label": {
      fontSize: 15,
    },
  },
  scroll: {
    "&::-webkit-scrollbar": { width: "20px" },
  },
  root2: {
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "13px 14px",
    },
    "& MuiInputLabel-root": {
      fontSize: 16,
    },
    "& label": {
      fontSize: 15,
    },
  },
}));
const FlightConfirmForm = ({ value }) => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [state, setState] = React.useState({});
  const [state2, setState2] = React.useState({});
  const [mealprice, setMeal] = useState(0);
  const [hold, setHold] = useState(false);
  const [meal1, setMeal1] = useState("");
  const [child1, setChild1] = React.useState(location.state.child1);
  const [child2, setChild2] = React.useState(location.state.child2);
  const [child3, setChild3] = React.useState(location.state.child3);
  const [child4, setChild4] = React.useState(location.state.child4);
  const [child5, setChild5] = React.useState(location.state.child4);
  const [child6, setChild6] = React.useState(location.state.child4);
  const [infant1, setInfant1] = React.useState(location.state.infant1);
  const [infant2, setInfant2] = React.useState(location.state.infant2);
  const [infant3, setInfant3] = React.useState(location.state.infant3);
  const [infant4, setInfant4] = React.useState(location.state.infant4);
  const [infant5, setInfant5] = React.useState(location.state.infant5);
  const [infant6, setInfant6] = React.useState(location.state.infant6);

  const [pay, setPay] = useState(false);
  const { agentlogin, travellerlogin } = useSelector((state) => state.user);
  const [addon, setAddon] = useState(0);
  const { payment, etravflightFare } = useSelector((state) => state.ui);
  const { ssrTBO, loading } = useSelector((state) => state.home);
  const { walletagent } = useSelector((state) => state.user);
  const { fareQuoteEtrav, fareQuote, onewayflightdata } = useSelector(
    (state) => state.home
  );
  const date = new Date();

  const getActualFormat = (given: number) => {
    if (given < 10) {
      return 0 + "" + given.toString();
    } else {
      return given;
    }
  };
  // const handleMeal = (value,index) => {
  //   setMeal(mealprice + value);
  //   setMeal1(1);
  // };
  const handleMeal = (value, code) => {
    let item = code;
    setState({ ...state, [item]: value });
  };
  const handleMValue = (code,mvalue)=>{
    setState2({...state,[code]:mvalue})
  }
  console.log("meal", mealprice);
  const invoice = [
    date.getFullYear(),
    getActualFormat(date.getMonth() + 1),
    getActualFormat(date.getDate()),
    getActualFormat(date.getHours()),
    getActualFormat(date.getMinutes()),
    getActualFormat(date.getSeconds()),
  ].join("");
  const [offline, setOffline] = useState(false);
  const [payworldline, setPayWorldline] = useState(false);
  let agentInfo = {
    email:
      agentlogin && agentlogin.status === 200
        ? agentlogin.result.result.email
        : "",
    id:
      agentlogin && agentlogin.status === 200
        ? agentlogin.result.result.id
        : "",
  };
  console.log("state", state);
  console.log("state2", state2);
  const handlePayment = (response) => {
    if (location.state.OneflightData.Airline_Code) {
      etravBooking(
        location,
        response,
        invoice,
        dispatch,
        agentInfo,
        fareQuoteEtrav,
        payment,
        FlightBookEtravDispatch,
        history,
        FlightTicketLCCDispatch,
        FlightBookDispatch,
        agentlogin
      );
    } else if (location.state.OneflightData.IsLCC) {
      tbobooking(
        location,
        response,
        invoice,
        dispatch,
        agentInfo,
        fareQuoteEtrav,
        payment,
        FlightBookEtravDispatch,
        history,
        FlightTicketLCCDispatch,
        FlightBookDispatch,
        agentlogin
      );
    } else {
      tbobookingnonlcc(
        location,
        response,
        invoice,
        dispatch,
        agentInfo,
        fareQuoteEtrav,
        payment,
        FlightBookEtravDispatch,
        history,
        FlightTicketLCCDispatch,
        FlightBookDispatch
      );
    }
  };
  const PGCharge = 200;
  const handleFormSubmit = (data) => {
    const selectedFlight = location.state.OneflightData;
    const priceDetails = fareQuoteEtrav
      ? fareQuoteEtrav.result.AirRepriceResponses[0]
      : fareQuote.result.Response;

    const payableAmout =
      location.state.OneflightData.Supplier === "ETR"
        ? Number(
          Math.round(
            location.state.OneflightData.Fares.Total_Amount
          )
        )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup)) + Number(Number(Number(
          Math.round(
            location.state.OneflightData.Fares.Total_Amount
          )
        )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup)))*2.5/100)
        : Number(
          Math.round(
            location.state.OneflightData.Fare.Total_Amount
          )
        )-Number(Math.round(location.state.OneflightData.Fare.agentMarkup)) + Number(Number(Number(
          Math.round(
            location.state.OneflightData.Fare.Total_Amount
          )
        )-Number(Math.round(location.state.OneflightData.Fare.agentMarkup)))*2.5/100)
    addBooking(
      location,
      agentlogin,
      payment,
      payableAmout,
      priceDetails,
      selectedFlight,
      dispatch,
      FlightAddBookingDispatch,
      PGCharge
    );

    if (payment === "pay") {
      // e.preventDefault();
      var options = {
        // key: "rzp_test_1xufv8E9EKecYL",
        // key_secret: "Ui7h6GeBLYxy1y75QaV6TgBz",
        key: "rzp_live_IZ3H2uQBdbxAbv",
        key_secret: "JVXsfYLHnTU4xk8uRGvmwZ2Q",
        amount: Number(Math.round(payableAmout)) * 100,

        currency: "INR",
        name: "Musafir Bazar",
        description: "for testing purpose",
        handler: handlePayment,
        prefill: {
          name: `${location.state.formData.first_name} ${location.state.formData.last_name}`,
          email: location.state.formData.email,
          contact: location.state.formData.phone,
        },
        notes: {
          address: location.state.formData.address,
        },
        theme: {
          color: "#3399cc",
        },
      };
      var pay = new window.Razorpay(options);
      pay.open();
    } else if (payment === "offline") {
      let res = "success";
      handlePayment(res);
    }else if(payment ==='payworldline'){
      dispatch(togglePGModal(true))
    }
  };
  const handleHold = (e) => {
    if (e.target.value === "payworldline") {
      dispatch(setPayment(e.target.value));
      if (payworldline) {
        setPay(false);
        setOffline(false);
        setPayWorldline(false);
      } else {
        setPayWorldline(true);
        setPay(false);
        setOffline(false);
      }
    } else if (e.target.value === "pay") {
      dispatch(setPayment(e.target.value));
      if (pay) {
        setPay(false);
        setOffline(false);
        setPayWorldline(false);
      } else {
        setPay(true);
        setPayWorldline(false);
        setOffline(false);
      }
    } else if (e.target.value === "offline") {
      dispatch(setPayment(e.target.value));
      if (offline) {
        setPay(false);
        setPayWorldline(false);
        setOffline(false);
      } else {
        setPay(false);
        setPayWorldline(false);
        setOffline(true);
      }
    }
    
    console.log(e.target.value);
  };
  const edit = () => {
    history.push({
      pathname: "/summaryflight",
      state: {
        formData: location.state.formData,
        body: location.state.body,
        OneflightData: location.state.OneflightData,
      },
    });
  };
  return (
    <>
      <Formik
        initialValues={{
          email: location.state.formData.email,
          phone: location.state.formData.phone,
          titleA1: location.state.formData.titleA1,
          first_nameA1: location.state.formData.first_nameA1,
          last_nameA1: location.state.formData.last_nameA1,
          titleA2: location.state.formData.titleA2,
          first_nameA2: location.state.formData.first_nameA2,
          last_nameA2: location.state.formData.last_nameA2,
          titleA3: location.state.formData.titleA3,
          first_nameA3: location.state.formData.first_nameA3,
          last_nameA3: location.state.formData.last_nameA3,
          titleA4: location.state.formData.titleA4,
          first_nameA4: location.state.formData.first_nameA4,
          last_nameA4: location.state.formData.last_nameA4,
          titleA5: location.state.formData.titleA5,
          first_nameA5: location.state.formData.first_nameA5,
          last_nameA5: location.state.formData.last_nameA5,
          titleA6: location.state.formData.titleA6,
          first_nameA6: location.state.formData.first_nameA6,
          last_nameA6: location.state.formData.last_nameA6,
          titleA7: location.state.formData.titleA7,
          first_nameA7: location.state.formData.first_nameA7,
          last_nameA7: location.state.formData.last_nameA7,
          titleA9: location.state.formData.titleA9,
          first_nameA9: location.state.formData.first_nameA9,
          last_nameA9: location.state.formData.last_nameA9,
          titleA8: location.state.formData.titleA8,
          first_nameA8: location.state.formData.first_nameA8,
          last_nameA8: location.state.formData.last_nameA8,
          titleC1: location.state.formData.titleC1,
          first_nameC1: location.state.formData.first_nameC1,
          last_nameC1: location.state.formData.last_nameC1,
          titleC2: location.state.formData.titleC2,
          first_nameC2: location.state.formData.first_nameC2,
          last_nameC2: location.state.formData.last_nameC2,
          titleC3: location.state.formData.titleC3,
          first_nameC3: location.state.formData.first_nameC3,
          last_nameC3: location.state.formData.last_nameC3,
          titleC4: location.state.formData.titleC4,
          first_nameC4: location.state.formData.first_nameC4,
          last_nameC4: location.state.formData.last_nameC4,
          titleC5: location.state.formData.titleC5,
          first_nameC5: location.state.formData.first_nameC5,
          last_nameC5: location.state.formData.last_nameC5,
          titleC6: location.state.formData.titleC6,
          first_nameC6: location.state.formData.first_nameC6,
          last_nameC6: location.state.formData.last_nameC6,
          titleI1: location.state.formData.titleI1,
          first_nameI1: location.state.formData.first_nameI1,
          last_nameI1: location.state.formData.last_nameI1,
          titleI2: location.state.formData.titleI2,
          first_nameI2: location.state.formData.first_nameI2,
          last_nameI2: location.state.formData.last_nameI2,
          titleI3: location.state.formData.titleI3,
          first_nameI3: location.state.formData.first_nameI3,
          last_nameI3: location.state.formData.last_nameI3,
          titleI4: location.state.formData.titleI4,
          first_nameI4: location.state.formData.first_nameI4,
          last_nameI4: location.state.formData.last_nameI4,
          titleI5: location.state.formData.titleI5,
          first_nameI5: location.state.formData.first_nameI5,
          last_nameI5: location.state.formData.last_nameI5,
          titleI6: location.state.formData.titleI6,
          first_nameI6: location.state.formData.first_nameI6,
          last_nameI6: location.state.formData.last_nameI6,
        }}
        validate={(values) => {
          const errors = {};

          return errors;
        }}
        onSubmit={handleFormSubmit}
      >
        {({ submitForm, isSubmitting, values, errors }) => (
          <>
            {" "}
            <Form>
              {/* Email and PhoneNumber Section */}
              <Box
                className={classes.root}
                style={{
                  background: "white",
                  padding: "10px 15px",
                  border: "1px solid #e6e6e6",
                  marginTop: "10px",
                  boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                  borderRadius: "5px",
                }}
              >
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  style={{ marginTop: 20, alignItems: "baseline" }}
                >
                  <Grid item xs={12} lg={6}>
                    <Field
                      component={TextField}
                      name="email"
                      type="email"
                      disabled
                      variant="outlined"
                      label="Email ID"
                      className={classes.selectField}
                      InputProps={{
                        className: classes.InputPropsStyle,
                      }}
                      inputProps={{
                        style: { padding: 12 },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <Field
                      component={TextField}
                      name="phone"
                      type="number"
                      disabled
                      variant="outlined"
                      error={errors.phone}
                      label="Mobile No."
                      className={classes.selectField}
                      InputProps={{
                        className: classes.InputPropsStyle,
                      }}
                      inputProps={{
                        style: { padding: 12 },
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
              {/* for adult 1 */}
              {location.state.body.AdultCount === 1 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      1
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Adult
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA1"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Select Title"
                        error={errors.titleA1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for adult 2 */}
              {location.state.body.AdultCount === 2 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      2
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Adult
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA1"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Select Title"
                        error={errors.titleA1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for adult 3 */}
              {location.state.body.AdultCount === 3 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      3
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Adult
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA1"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Select Title"
                        error={errors.titleA1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for adult 4 */}
              {location.state.body.AdultCount === 4 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      3
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Adult
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for adult 5 */}
              {location.state.body.AdultCount === 5 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      5
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Adult
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA5}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for adult 6 */}
              {location.state.body.AdultCount === 6 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      6
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Adult
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA5}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA6}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA6"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for adult 7 */}
              {location.state.body.AdultCount === 7 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      7
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Adult
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA5}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA6}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA7"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA6}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA7"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA7"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for adult 8 */}
              {location.state.body.AdultCount === 8 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      8
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Adult
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA5"
                        type="text"
                        variant="outlined"
                        label="Select Title"
                        disabled
                        error={errors.titleA5}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA6}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA7"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA7}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA7"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA7"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA8"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA8}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA8"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA8"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for adult 9 */}
              {location.state.body.AdultCount === 9 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      9
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Adult
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA5}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA6}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA7"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA7}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA7"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA7"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA8"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Select Title"
                        error={errors.titleA8}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA8"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA8"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA9"
                        disabled
                        type="text"
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleA9}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA9"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA9"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for ChildCount 1 */}
              {location.state.body.ChildCount === 1 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      1
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Child
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child1}
                          onChange={(newValue) => {
                            setChild1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for ChildCount 2 */}
              {location.state.body.ChildCount === 2 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      2
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Child
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC1"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child1}
                          onChange={(newValue) => {
                            setChild1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC2"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Select Title"
                        error={errors.titleC2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child2}
                          onChange={(newValue) => {
                            setChild2(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for Child 3 */}
              {location.state.body.ChildCount === 3 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      3
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Child
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child1}
                          onChange={(newValue) => {
                            setChild1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child2}
                          onChange={(newValue) => {
                            setChild2(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child3}
                          onChange={(newValue) => {
                            setChild3(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for Child 4 */}
              {location.state.body.ChildCount === 4 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      4
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Child
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child1}
                          onChange={(newValue) => {
                            setChild1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child2}
                          onChange={(newValue) => {
                            setChild2(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child3}
                          onChange={(newValue) => {
                            setChild3(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child4}
                          onChange={(newValue) => {
                            setChild4(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for Child 5 */}
              {location.state.body.ChildCount === 5 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      5
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Child
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC1"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Select Title"
                        error={errors.titleC1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child1}
                          onChange={(newValue) => {
                            setChild1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child2}
                          onChange={(newValue) => {
                            setChild2(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child3}
                          onChange={(newValue) => {
                            setChild3(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC4"
                        disabled
                        type="text"
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child4}
                          onChange={(newValue) => {
                            setChild4(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC5}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child5}
                          onChange={(newValue) => {
                            setChild5(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for Child 6 */}
              {location.state.body.ChildCount === 6 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      6
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Child
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child1}
                          onChange={(newValue) => {
                            setChild1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child2}
                          onChange={(newValue) => {
                            setChild2(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child3}
                          onChange={(newValue) => {
                            setChild3(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child4}
                          onChange={(newValue) => {
                            setChild4(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC5}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child5}
                          onChange={(newValue) => {
                            setChild5(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC6}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameC6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameC6"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={child6}
                          onChange={(newValue) => {
                            setChild6(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for InfantCount 1 */}
              {location.state.body.InfantCount === 1 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      1
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Infant
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant1}
                          onChange={(newValue) => {
                            setInfant1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for ChildCount 2 */}
              {location.state.body.InfantCount === 2 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      2
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Infant
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI1"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant1}
                          onChange={(newValue) => {
                            setInfant1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI2"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Select Title"
                        error={errors.titleC2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant2}
                          onChange={(newValue) => {
                            setInfant2(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for Child 3 */}
              {location.state.body.InfantCount === 3 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      3
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Infant
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant1}
                          onChange={(newValue) => {
                            setInfant1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleC2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant2}
                          onChange={(newValue) => {
                            setInfant2(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant3}
                          onChange={(newValue) => {
                            setInfant3(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for Child 4 */}
              {location.state.body.InfantCount === 4 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      4
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Infant
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant1}
                          onChange={(newValue) => {
                            setInfant1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant2}
                          onChange={(newValue) => {
                            setInfant2(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant3}
                          onChange={(newValue) => {
                            setInfant3(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant4}
                          onChange={(newValue) => {
                            setInfant4(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for Child 5 */}
              {location.state.body.InfantCount === 5 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      5
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Infant
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI1"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Select Title"
                        error={errors.titleI1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant1}
                          onChange={(newValue) => {
                            setInfant1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant2}
                          onChange={(newValue) => {
                            setInfant2(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant3}
                          onChange={(newValue) => {
                            setInfant3(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI4"
                        disabled
                        type="text"
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant4}
                          onChange={(newValue) => {
                            setInfant4(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI5}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant5}
                          onChange={(newValue) => {
                            setInfant5(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* for Infant 6 */}
              {location.state.body.InfantCount === 6 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      6
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Infant
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleC1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant1}
                          onChange={(newValue) => {
                            setInfant1(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI2}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI2"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant2}
                          onChange={(newValue) => {
                            setInfant2(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI3}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI3"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant3}
                          onChange={(newValue) => {
                            setInfant3(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI4}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI4"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant4}
                          onChange={(newValue) => {
                            setInfant4(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI5}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI5"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant5}
                          onChange={(newValue) => {
                            setInfant5(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={3}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleI6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Select Title"
                        error={errors.titleI6}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="first_nameI6"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <Field
                        component={TextField}
                        name="last_nameI6"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          // disableFuture
                          // label='Date'
                          disabled
                          openTo="months"
                          // minDate={new Date('2012-05-12')}
                          // maxDate={value}
                          views={["year", "month", "day"]}
                          value={infant6}
                          onChange={(newValue) => {
                            setInfant6(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField2
                              {...params}
                              variant="outlined"
                              name="date"
                              // error={errors.date}
                              // className={classes.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* meal section */}
              {/* <Box
                alignItems="center"
                display="flex"
                style={{
                  background: "white",
                  padding: "10px 15px",
                  border: "1px solid #e6e6e6",
                  marginTop: "10px",
                  boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                  borderRadius: "5px",
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  style={{
                    borderBottom: addon === 0 ? "4px solid #0091ff" : "",
                    cursor: "pointer",
                  }}
                  onClick={() => setAddon(0)}
                >
                  <img
                    src={seat}
                    alt="seat"
                    style={{ width: 24, height: 24 }}
                  />
                  <h4>Seat</h4>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  ml={"20px"}
                  style={{
                    borderBottom: addon === 1 ? "4px solid #0091ff" : "",
                    cursor: "pointer",
                  }}
                  onClick={() => setAddon(1)}
                >
                  <img
                    src={meal}
                    alt="meal"
                    style={{ width: 24, height: 24 }}
                  />
                  <h4>Meals</h4>
                </Box>
              </Box>
              {addon === 0 ? (
                <Box
                  style={{
                    backgroundColor: "#f4f4f4",
                    padding: 20,
                    maxHeight: 400,
                    overflow: "auto",
                    scrollBehavior: "smooth",
                    position: "relative",
                  }}
                  className={classes.scroll}
                >
                  <Seat />
                </Box>
              ) : (
                <Box
                  style={{
                    backgroundColor: "#f4f4f4",
                    padding: 20,
                    maxHeight: 400,
                    overflow: "auto",
                    scrollBehavior: "smooth",
                    position: "relative",
                  }}
                  className={classes.scroll}
                >
                  {loading ? (
                    <></>
                  ) : (
                    ssrTBO &&
                    ssrTBO.result &&
                    ssrTBO.result.Response &&
                    ssrTBO.result.Response.MealDynamic[0].map((i, index) => {
                      return (
                        <Box
                          style={{
                            backgroundColor: "#ffff",
                            padding: 10,
                            borderRadius: 5,
                            marginTop: 10,
                          }}
                          justifyContent="space-between"
                          display="flex"
                          alignItems="center"
                        >
                          <Box style={{}}>
                            <h5>{i.AirlineDescription}</h5>
                            <h5>{state[i.Code]}</h5>
                            <h6>{`Rs ${i.Price}`}</h6>
                          </Box>
                          {state[i.Code] === i.Price ? (
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              style={{
                                borderRadius: "3px",
                                boxShadow: "0 0 5px 0 rgb(0 0 0 / 20%)",
                                backgroundColor: "#fff",
                                width: "90px",
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#008cff",
                                textTransform: "uppercase",
                                outline: "0",
                                border: 0,
                                padding: "0px 10px",
                              }}
                            >
                              <Box>
                                <h4>-</h4>
                              </Box>
                              <Box>
                                <h4>5</h4>
                              </Box>
                              <Box onClick={()=>handleMValue(i.Code,index+1)}>
                                <h4>+</h4>
                              </Box>
                            </Box>
                          ) : (
                            <Box
                              style={{
                                borderRadius: "3px",
                                boxShadow: "0 0 5px 0 rgb(0 0 0 / 20%)",
                                backgroundColor: "#fff",
                                width: "90px",
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#008cff",
                                textTransform: "uppercase",
                                outline: "0",
                                border: 0,
                                padding: "8px",
                              }}
                            >
                              <span onClick={() => {handleMeal(i.Price, i.Code);handleMValue(i.Code,index-index+1)}}>
                                ADD
                              </span>
                            </Box>
                          )}
                          <Box
                          style={{
                            borderRadius: "3px",
                            boxShadow: "0 0 5px 0 rgb(0 0 0 / 20%)",
                            backgroundColor: "#fff",
                            width: "90px",
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: "700",
                            color: "#008cff",
                            textTransform: "uppercase",
                            outline: "0",
                            border: 0,
                            padding: "8px",
                          }}
                        >
                          <span onClick={()=>handleMeal(i.Price)}>ADD</span>
                          
                        </Box>
                        </Box>
                      );
                    })
                  )}
                </Box>
              )} */}

              {/* payment method */}
              <Box
                alignItems="center"
                display="flex"
                style={{
                  background: "white",
                  padding: "10px 15px",
                  border: "1px solid #e6e6e6",
                  marginTop: "10px",
                  boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                  borderRadius: "5px",
                }}
              >
                {agentlogin &&
                agentlogin.result &&
                agentlogin.result.result &&
                agentlogin.result.result.role === "Agent" ? (
                  <>
                    <FormControlLabel
                      style={{ marginRight: 0 }}
                      value="offline"
                      control={
                        <Radio
                          checked={offline}
                          onClick={handleHold}
                          disabled={
                            location.state.OneflightData.AirlineCode
                              ? Number(
                                  Math.round(
                                    location.state.OneflightData.Fare
                                      .Total_Amount
                                  )
                                ) <
                                Number(
                                  Math.round(
                                    walletagent &&
                                      walletagent.result.balanceAmount
                                  )
                                )
                                ? false
                                : true
                              : location.state.OneflightData.Airline_Code
                              ? Number(
                                  Math.round(
                                    location.state.OneflightData.Fares
                                      .Total_Amount
                                  )
                                ) <
                                Number(
                                  Math.round(
                                    walletagent &&
                                      walletagent.result.balanceAmount
                                  )
                                )
                                ? false
                                : true
                              : ""
                          }
                        />
                      }
                    />
                    <span
                      style={{
                        opacity: location.state.OneflightData.AirlineCode
                          ? Number(
                              Math.round(
                                location.state.OneflightData.Fare.Total_Amount
                              )
                            ) <
                            Number(
                              Math.round(
                                walletagent && walletagent.result.balanceAmount
                              )
                            )
                            ? ""
                            : 0.3
                          : location.state.OneflightData.Airline_Code
                          ? Number(
                              Math.round(
                                location.state.OneflightData.Fares.Total_Amount
                              )
                            ) <
                            Number(
                              Math.round(
                                walletagent && walletagent.result.balanceAmount
                              )
                            )
                            ? ""
                            : 0.3
                          : "",
                      }}
                    >
                      Offline Amount
                    </span>
                    <span
                      style={{
                        marginLeft: 5,
                        color: "blue",
                        opacity: location.state.OneflightData.AirlineCode
                          ? Number(
                              Math.round(
                                location.state.OneflightData.Fare.Total_Amount
                              )
                            ) <
                            Number(
                              Math.round(
                                walletagent && walletagent.result.balanceAmount
                              )
                            )
                            ? ""
                            : 0.3
                          : location.state.OneflightData.Airline_Code
                          ? Number(
                              Math.round(
                                location.state.OneflightData.Fares.Total_Amount
                              )
                            ) <
                            Number(
                              Math.round(
                                walletagent && walletagent.result.balanceAmount
                              )
                            )
                            ? ""
                            : 0.3
                          : "",
                      }}
                    >
                      {" "}
                      {location.state.OneflightData.AirlineCode
                        ? Number(
                            Math.round(
                              location.state.OneflightData.Fare.Total_Amount
                            )
                          )-Number(Math.round(location.state.OneflightData.Fare.MFB_Discount))-Number(Math.round(location.state.OneflightData.Fare.agentMarkup))
                        : Number(
                            Math.round(
                              location.state.OneflightData.Fares.Total_Amount
                            )
                          )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup))}
                    </span>
                    {/* <FormControlLabel
											style={{ marginRight: 0, marginLeft: 10 }}
											value='hold'
											control={
												<Radio
													checked={hold}
													onClick={handleHold}
													style={{ marginLeft: 10 }}
												/>
											}
											// label='Hold'
										/>
										<span>Hold</span> */}
                  </>
                ) : (
                  ""
                )}

                <FormControlLabel
                  style={{ marginRight: 0, marginLeft: 10 }}
                  value="pay"
                  control={
                    <Radio
                      checked={pay}
                      onClick={handleHold}
                      style={{ marginLeft: 10 }}
                    />
                  }
                  // label='Pay Online'
                />
                <span>Pay With Razorpay</span>
                <span style={{ marginLeft: 5, color: "blue" }}>
                  {" "}
                  {location.state.OneflightData.Supplier === "TBO"
                    ? Number(
                        Math.round(
                          location.state.OneflightData.Fare.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fare.agentMarkup)) + Number(Math.round(Number(Number(
                        Math.round(
                          location.state.OneflightData.Fare.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fare.agentMarkup)))*2.5/100))
                    : Number(
                        Math.round(
                          location.state.OneflightData.Fares.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup)) + Number(Math.round(Number(Number(
                        Math.round(
                          location.state.OneflightData.Fares.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup)))*2.5/100))}
                </span>
                {/* <FormControlLabel
                  style={{ marginRight: 0, marginLeft: 10 }}
                  value="payworldline"
                  control={
                    <Radio
                      checked={payworldline}
                      onClick={handleHold}
                      style={{ marginLeft: 10 }}
                    />
                  }
                  // label='Pay Online'
                />
                <span>Pay With Worline</span>
                <span style={{ marginLeft: 5, color: "blue" }}>
                  {" "}
                  {location.state.OneflightData.Supplier === "TBO"
                    ? Number(
                        Math.round(
                          location.state.OneflightData.Fare.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fare.agentMarkup)) + Number(Math.round(Number(Number(
                        Math.round(
                          location.state.OneflightData.Fare.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fare.agentMarkup)))*2.5/100))
                    : Number(
                        Math.round(
                          location.state.OneflightData.Fares.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup)) + Number(Math.round(Number(Number(
                        Math.round(
                          location.state.OneflightData.Fares.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup)))*2.5/100))}
                </span> */}
              </Box>
              {/* Submit and Edit Button */}
              <Grid container spacing={2}>
                <Grid item xs={4} lg={2}>
                  <Button
                    className={classes.createButton}
                    onClick={edit}
                    style={{ marginTop: 10, fontSize: 14 }}
                    // disabled={isSubmitting}
                  >
                    EDIT
                  </Button>
                </Grid>
                <Grid item xs={8} lg={4}>
                  <Button
                    className={classes.createButton}
                    onClick={handleFormSubmit}
                    style={{ marginTop: 10, fontSize: 14 }}
                    // disabled={isSubmitting}
                  >
                    PROCESS TO PAYMENT
                  </Button>
                </Grid>
                <Grid item xs={4}></Grid>
              </Grid>
            </Form>
          </>
        )}
      </Formik>
      <ErrorModal />
      <WorldlinePG/>
      <BookingAlreadyPNRModal />
    </>
  );
};

export default FlightConfirmForm;
